import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const NoSearchResTips = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.string,
        };
        static defaultProps = {
            content: {},
        };
        /**
         * 插入html
         */
        createChannelInfo = () => {
            return { __html: this.props.content };
        };

        render() {
            return <div dangerouslySetInnerHTML={this.createChannelInfo()} />;
        }
    },
);

export default NoSearchResTips;
